import { render, staticRenderFns } from "./EditReaction.vue?vue&type=template&id=3ead6120"
import script from "./EditReaction.vue?vue&type=script&lang=js"
export * from "./EditReaction.vue?vue&type=script&lang=js"
import style0 from "./EditReaction.vue?vue&type=style&index=0&id=3ead6120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports